var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"var(--iconFill, #000000)"},"d":"m31.8 13.27c.02.26.02.53.02.79 0 8.05-6.13 17.32-17.32 17.32-3.45 0-6.65-1-9.35-2.73.49.06.96.08 1.47.08 2.85 0 5.47-.96 7.56-2.6-2.68-.06-4.92-1.81-5.69-4.22.38.06.75.09 1.15.09.55 0 1.09-.08 1.6-.21-2.79-.57-4.88-3.02-4.88-5.98v-.08c.81.45 1.75.74 2.75.77-1.64-1.09-2.71-2.96-2.71-5.07 0-1.13.3-2.17.83-3.07 3 3.69 7.5 6.11 12.55 6.37-.09-.45-.15-.92-.15-1.39 0-3.36 2.71-6.09 6.09-6.09 1.75 0 3.34.74 4.45 1.92 1.38-.26 2.7-.77 3.86-1.47-.45 1.41-1.41 2.6-2.68 3.36 1.23-.13 2.41-.47 3.51-.94-.84 1.2-1.87 2.28-3.06 3.15z"}));
}

Twitter.defaultProps = {"enableBackground":"new 0 0 40 40","viewBox":"0 0 40 40"};

module.exports = Twitter;

Twitter.default = Twitter;
